import React, { useEffect, useState } from 'react';
import { Colors } from '../theme';
import { subscribeTonyteConfirmation, type TonyteConfirmationRequest } from '../utils/tonyteConfirmation';
import TonyteModal from './TonyteModal';

const TonyteConfirmationHost: React.FC = () => {
  const [request, setRequest] = useState<TonyteConfirmationRequest | null>(null);

  useEffect(() => subscribeTonyteConfirmation(setRequest), []);

  const finish = (confirmed: boolean) => {
    const current = request;
    setRequest(null);
    current?.resolve(confirmed);
  };

  return (
    <TonyteModal
      visible={Boolean(request)}
      title={request?.title || ''}
      message={request?.message}
      icon={request?.icon || 'heart'}
      iconColor={Colors.sunset}
      buttons={request ? [
        { label: request.cancelLabel, variant: 'secondary', onPress: () => finish(false) },
        { label: request.confirmLabel, variant: 'primary', onPress: () => finish(true) },
      ] : []}
      onDismiss={() => finish(false)}
    />
  );
};

export default TonyteConfirmationHost;
